import VTreeview from './VTreeview/VTreeview.vue'

export default VTreeview


// WEBPACK FOOTER //
// ./src/index.js